/**
 * A leitura das publicações em páginas PARALELAS — usada pelo editor
 * (`api.ts`) e pelo link do cliente (`share/api.ts`). O servidor diz de
 * antemão onde começa cada página (`publication-cursors`), e a tela pede
 * várias ao mesmo tempo.
 */

/** Publicações por página. */
export const PUBLICATION_PAGE = 5000;
/** Páginas pedidas ao mesmo tempo: o servidor lê e converte cada uma em
 * ~2 s, e uma depois da outra uma base de 60 mil levava quase um minuto. */
const PARALLEL_PAGES = 4;

/** `load` sobre cada item, `PARALLEL_PAGES` por vez, devolvendo na ORDEM
 * dos itens (a ordem importa: entre bases, a repetida que fica é a da
 * primeira base). */
export async function inParallel<T, R>(
  items: readonly T[],
  load: (item: T) => Promise<R>,
  onProgress?: (done: number, total: number) => void,
): Promise<R[]> {
  const results = new Array<R>(items.length);
  let next = 0;
  let done = 0;
  onProgress?.(0, items.length);
  const worker = async () => {
    while (next < items.length) {
      const index = next++;
      results[index] = await load(items[index]!);
      onProgress?.(++done, items.length);
    }
  };
  await Promise.all(Array.from({ length: Math.min(PARALLEL_PAGES, items.length) }, worker));
  return results;
}
